import type { User, UserPermission } from './index.js';

export function hasUserPermission(
  user: Pick<User, 'role' | 'permissions'> | null | undefined,
  permission: UserPermission,
): boolean {
  if (!user) return false;
  if (user.permissions != null) return user.permissions.includes(permission);
  if (user.role === 'ADMIN') return true;
  return (
    user.role === 'OPERATOR' &&
    (permission === 'inventory.read' || permission === 'inventory.adjust')
  );
}
